// AUTO-GENERATED - do not hand-edit.
// Generated from src/Evergreen.Contracts by scripts/gen-types.cjs (see decisions.md D-221).
// Regenerate after any Contracts DTO change: node scripts/gen-types.cjs
/* eslint-disable */

// ---- Enums ----

export type ArtifactFormat =
  | "Pptx"
  | "Pdf"
  | "Xlsx"
  | "Html"
  | "Json";

export type AuditScope =
  | "None"
  | "OwnActionsOnly"
  | "All";

export type ChildLinkOutcome =
  | "LinkedByProjectKey"
  | "LinkedByBusinessId"
  | "Ambiguous"
  | "Orphaned"
  | "Unlinked";

export type CssCompatibilityLevel =
  | "Modern"
  | "NoColorMix";

export type DataQualitySeverity =
  | "Info"
  | "Warning"
  | "Error";

export type DateParseKind =
  | "Empty"
  | "Exact"
  | "MonthOnly"
  | "Placeholder"
  | "Unparseable";

export type DeckVersionAction =
  | "Publish"
  | "Finalize"
  | "Archive"
  | "ReExport"
  | "Edit";

export type DeckVersionState =
  | "Draft"
  | "Published"
  | "Final"
  | "Archived";

export type DetailSelectionMode =
  | "Derived"
  | "ManualOverride"
  | "DerivedWithOverrides";

export type DetailSelectionReason =
  | "Pinned"
  | "Excluded"
  | "RuleSatisfied"
  | "BelowMilestoneThreshold"
  | "StatGroupNotIncluded"
  | "StatusUnmapped"
  | "NotOnCuratedList"
  | "DroppedByMaxSlides";

export type ExportSource =
  | "DeckVersion"
  | "Live";

export type FilterEffect =
  | "Hide"
  | "Dim";

export type FilterSelectionMode =
  | "SingleSelect"
  | "MultiSelectAdditive";

export type GoLivePrecedence =
  | "OriginalFirst"
  | "CurrentFirst";

export type GoLiveSource =
  | "ExplicitMilestoneFlag"
  | "MilestoneDescriptionMatch"
  | "CurrentProjection"
  | "OriginalEstimate"
  | "Unresolved";

export type MergeOutcome =
  | "NothingToWrite"
  | "LastWriteWins";

export type MilestoneChangeKind =
  | "Added"
  | "Removed"
  | "Changed";

export type MilestoneDisplayMode =
  | "CappedList"
  | "ScrollingTimeline";

export type QuarterAssignmentReason =
  | "WithinColumn"
  | "OpenEndedColumn"
  | "PastOrStaleEstimate"
  | "TimingNotProvided"
  | "DateUnparseable"
  | "PlaceholderTimingColumn"
  | "LifecycleStatusColumn";

export type QuarterSelectorMode =
  | "CurrentQuarterByClock"
  | "FirstForwardColumn"
  | "ExplicitColumnKey";

export type ShapeGeometry =
  | "Rectangle"
  | "RoundedRectangle"
  | "Ellipse"
  | "Line";

export type SlideElementKind =
  | "Shape"
  | "Text"
  | "Image"
  | "Table";

export type StatCardKind =
  | "TotalCount"
  | "StatGroupCount"
  | "QuarterGoLiveCount"
  | "OpenRiskNoteCount";

export type TextAlignment =
  | "Left"
  | "Center"
  | "Right";

export type UnknownFieldPolicy =
  | "ReportAsIgnored"
  | "Warn"
  | "Reject";

// ---- Coded-string catalogs (reason/issue codes) ----

export const AdministrationIssueCodes = {
  RoleUnrecognized: "ADMIN_ROLE_UNRECOGNIZED",
  PrincipalUnknown: "ADMIN_PRINCIPAL_UNKNOWN",
  ConcurrencyConflict: "ADMIN_CONCURRENCY_CONFLICT",
  StoreRefused: "ADMIN_STORE_REFUSED",
  ReferenceGroupUnknown: "ADMIN_REFERENCE_GROUP_UNKNOWN",
  ReferenceListRequired: "ADMIN_REFERENCE_LIST_REQUIRED",
  FieldMapUnusable: "ADMIN_FIELDMAP_UNUSABLE",
  FieldMapUnknown: "ADMIN_FIELDMAP_UNKNOWN",
} as const;

export const AuditActions = {
  UserProvisioned: "user.provision",
  UserRoleAssigned: "user.role.assign",
  ReferenceValueSaved: "reference.value.save",
  LayoutSettingsSaved: "layout.settings.save",
  BrandingSaved: "branding.save",
  FieldMapSaved: "fieldmap.save",
  FieldMapActivated: "fieldmap.activate",
  ProjectSaved: "project.save",
  MilestoneSaved: "milestone.save",
  NoteSaved: "note.save",
  RequestSaved: "request.save",
  MilestonesReordered: "milestone.reorder",
  ProductSaved: "product.save",
  EntityDeleted: "entity.delete",
  ArtifactExported: "export.create",
  WorkbookImported: "import.workbook",
  SourceSynchronized: "source.sync",
  SourcesCompared: "source.compare",
  DeckPublished: "deck.publish",
  DeckFinalized: "version.finalize",
} as const;

export const AuthorizationReasonCodes = {
  RoleUnrecognized: "AUTHZ_ROLE_UNRECOGNIZED",
  OperationUnknown: "AUTHZ_OPERATION_UNKNOWN",
  OperationDenied: "AUTHZ_OPERATION_DENIED",
  PrincipalUnknown: "AUTHZ_PRINCIPAL_UNKNOWN",
  PrincipalDisabled: "AUTHZ_PRINCIPAL_DISABLED",
} as const;

export const ChangeFacts = {
  Kind: "change.kind",
  Created: "created",
  Updated: "updated",
  Deleted: "deleted",
  Subject: "change.subject",
  Parent: "change.parent",
  BeforePrefix: "change.before.",
  AfterPrefix: "change.after.",
  NameField: "name",
  StatusField: "status",
  GoLiveField: "goLive",
  DateField: "date",
  DispositionField: "disposition",
} as const;

export const ChangeKinds = {
  Created: "Created",
  Updated: "Updated",
  Deleted: "Deleted",
  Reordered: "Reordered",
} as const;

export const DataQualityCodes = {
  UnmappedReferenceValue: "REF_UNMAPPED_VALUE",
  StatusUnmapped: "DQ_STATUS_UNMAPPED",
  DuplicateProjectId: "DQ_DUPLICATE_PROJECT_ID",
  AmbiguousChildLink: "DQ_AMBIGUOUS_CHILD_LINK",
  OrphanedChildRecord: "DQ_ORPHANED_CHILD_RECORD",
  DateUnparseable: "DQ_DATE_UNPARSEABLE",
  PlaceholderStillPresent: "DQ_PLACEHOLDER_PRESENT",
  PercentMissingOnActiveProject: "DQ_PERCENT_MISSING",
  PercentOutOfRange: "DQ_PERCENT_OUT_OF_RANGE",
  ProjectWithoutMilestones: "DQ_NO_MILESTONES",
  MilestoneWithoutDescription: "DQ_MILESTONE_NO_DESCRIPTION",
  GoLiveResolvedFromOriginal: "DQ_GOLIVE_FROM_ORIGINAL",
  GoLivePastDue: "DQ_GOLIVE_PAST_DUE",
  TeamGroupUnresolved: "DQ_TEAM_GROUP_UNRESOLVED",
} as const;

export const EntityTypes = {
  Project: "Project",
  Milestone: "Milestone",
  Note: "Note",
  Request: "Request",
  ReferenceValue: "ReferenceValue",
  Product: "Product",
  User: "User",
  AuditEntry: "AuditEntry",
  LayoutSettings: "LayoutSettings",
  Branding: "Branding",
  FieldMapProfile: "FieldMapProfile",
  DeckVersion: "DeckVersion",
  PortfolioSource: "PortfolioSource",
  Artifact: "Artifact",
} as const;

export const ExportIssueCodes = {
  VersionKeyRequired: "EXPORT_VERSION_KEY_REQUIRED",
  VersionKeyNotApplicable: "EXPORT_VERSION_KEY_NOT_APPLICABLE",
  FilterNotApplicable: "EXPORT_FILTER_NOT_APPLICABLE",
  VersionNotFound: "EXPORT_VERSION_NOT_FOUND",
  SnapshotCorrupt: "EXPORT_SNAPSHOT_CORRUPT",
  ArtifactNotFound: "EXPORT_ARTIFACT_NOT_FOUND",
} as const;

export const IngestionIssueCodes = {
  ProfileNotResolved: "INGEST_PROFILE_NOT_RESOLVED",
  UploadEmpty: "INGEST_UPLOAD_EMPTY",
  MappingUnusable: "INGEST_MAPPING_UNUSABLE",
  WarningsNotAccepted: "INGEST_WARNINGS_NOT_ACCEPTED",
  DuplicateBusinessIds: "INGEST_DUPLICATE_BUSINESS_IDS",
  DualRunSourcesIdentical: "INGEST_DUAL_RUN_SOURCES_IDENTICAL",
  SourceUnhealthy: "INGEST_SOURCE_UNHEALTHY",
} as const;

export const LifecycleReasonCodes = {
  FinalIsTerminal: "LIFECYCLE_FINAL_TERMINAL",
  ArchivedIsRetired: "LIFECYCLE_ARCHIVED_RETIRED",
  NotYetPublished: "LIFECYCLE_NOT_YET_PUBLISHED",
  ContentFrozen: "LIFECYCLE_CONTENT_FROZEN",
  AlreadyInState: "LIFECYCLE_ALREADY_IN_STATE",
} as const;

export const PortfolioIssueCodes = {
  StoreRefused: "PORTFOLIO_STORE_REFUSED",
  ProjectNameRequired: "PORTFOLIO_PROJECT_NAME_REQUIRED",
  ProjectKeyRequired: "PORTFOLIO_PROJECT_KEY_REQUIRED",
  UnknownEntityType: "PORTFOLIO_UNKNOWN_ENTITY_TYPE",
  ProductNameRequired: "PORTFOLIO_PRODUCT_NAME_REQUIRED",
  ProductUnavailable: "PORTFOLIO_PRODUCT_UNAVAILABLE",
  ReorderMalformed: "PORTFOLIO_REORDER_MALFORMED",
  NotFound: "PORTFOLIO_NOT_FOUND",
  DateEchoBack: "PORTFOLIO_DATE_ECHO",
} as const;

export const PortfolioOperations = {
  RoadmapView: "roadmap.view",
  VersionView: "version.view",
  ExportCreate: "export.create",
  ProjectUpdate: "project.update",
  ProjectImport: "project.import",
  DeckGenerate: "deck.generate",
  DeckPublish: "deck.publish",
  VersionFinalize: "version.finalize",
  ConfigurationManage: "configuration.manage",
  UserManage: "user.manage",
  AuditView: "audit.view",
} as const;

export const PortfolioRoles = {
  Viewer: "Viewer",
  Contributor: "Contributor",
  ProjectManager: "ProjectManager",
  Admin: "Admin",
} as const;

export const PublicationIssueCodes = {
  PreconditionsFailed: "PUBLISH_PRECONDITIONS_FAILED",
  VersionNotFound: "PUBLISH_VERSION_NOT_FOUND",
  SnapshotMissing: "PUBLISH_SNAPSHOT_MISSING",
  SnapshotCorrupt: "PUBLISH_SNAPSHOT_CORRUPT",
  TransitionDenied: "PUBLISH_TRANSITION_DENIED",
  RenderFailed: "PUBLISH_RENDER_FAILED",
  VersionStoreRefused: "PUBLISH_VERSION_STORE_REFUSED",
  ComparandsIdentical: "PUBLISH_COMPARANDS_IDENTICAL",
} as const;

export const PublishValidationCodes = {
  TitleMissing: "PUBLISH_TITLE_MISSING",
  ReportDateUnset: "PUBLISH_REPORT_DATE_UNSET",
  DataAsOfInFuture: "PUBLISH_DATA_AS_OF_IN_FUTURE",
  SchemaVersionMissing: "PUBLISH_SCHEMA_VERSION_MISSING",
  IntegrityHashMissing: "PUBLISH_INTEGRITY_HASH_MISSING",
  NoProjects: "PUBLISH_NO_PROJECTS",
  ReferenceDataEmpty: "PUBLISH_REFERENCE_DATA_EMPTY",
  QuarterColumnsUnresolved: "PUBLISH_QUARTER_COLUMNS_UNRESOLVED",
  DetailSelectionUnresolved: "PUBLISH_DETAIL_SELECTION_UNRESOLVED",
  BrandAssetUnhashed: "PUBLISH_BRAND_ASSET_UNHASHED",
  DataQualityErrorsPresent: "PUBLISH_DATA_QUALITY_ERRORS",
  ColourUnresolvable: "PUBLISH_COLOUR_UNRESOLVABLE",
} as const;

export const SnapshotIntegrityCodes = {
  HashMissing: "SNAPSHOT_HASH_MISSING",
  HashMismatch: "SNAPSHOT_HASH_MISMATCH",
  SchemaVersionMissing: "SNAPSHOT_SCHEMA_VERSION_MISSING",
  SchemaVersionUnsupported: "SNAPSHOT_SCHEMA_VERSION_UNSUPPORTED",
  BrandAssetUnhashed: "SNAPSHOT_BRAND_ASSET_UNHASHED",
} as const;

export const SourceVocabularyOwnership = {
  Application: "application",
  Source: "source",
  Shared: "shared",
} as const;

// ---- DTOs ----

export interface AccessDecision {
  isAllowed: boolean;
  operation: string;
  reasonCode: string | null;
}

export interface ArtifactContent {
  format: ArtifactFormat;
  mediaType: string;
  fileName: string;
  content: string;
}

export interface ArtifactMetadata {
  purpose: string;
  deckVersionKey: string | null;
  createdByPrincipalId: string;
  correlationId: string;
  expiresAtUtc: string | null;
  tags: Record<string, string>;
}

export interface ArtifactRef {
  artifactKey: string;
  format: ArtifactFormat;
  fileName: string;
  mediaType: string;
  sizeBytes: number;
  contentHash: string;
  createdAtUtc: string;
}

export interface AuditEntry {
  entryKey: string;
  actorPrincipalId: string;
  actorDisplayName: string;
  action: string;
  entityType: string;
  entityKey: string | null;
  teamCode: string | null;
  atUtc: string;
  correlationId: string;
}

export interface AuditEntryDetail {
  entry: AuditEntry;
  beforeState: string | null;
  afterState: string | null;
  context: Record<string, string>;
}

export interface AuditQuery {
  actorPrincipalId: string | null;
  action: string | null;
  entityType: string | null;
  entityKey: string | null;
  teamCode: string | null;
  fromInclusiveUtc: string | null;
  toExclusiveUtc: string | null;
  pageNumber: number;
  pageSize: number;
}

export interface AuthenticationTicket {
  scheme: string;
  rawToken: string;
  correlationId: string | null;
}

export interface BoardChip {
  projectKey: string;
  columnKey: string;
  label: string;
  colorHex: string;
  statusCanonical: string;
  percentComplete: number | null;
}

export interface BrandAssetContent {
  contentHash: string;
  mediaType: string;
  content: string;
}

export interface BrandAssetRef {
  role: string;
  contentHash: string;
  storageKey: string;
  mediaType: string;
  pixelWidth: number;
  pixelHeight: number;
}

export interface BrandingSaveRequest {
  tokens: BrandingTokens;
}

export interface BrandingTokens {
  colors: Record<string, string>;
  headline: FontSpec;
  body: FontSpec;
  assets: BrandAssetRef[];
}

export interface BroadcastHealth {
  isAvailable: boolean;
  transportDescription: string;
  deliveredCount: number;
  failedCount: number;
  lastFailureAtUtc: string | null;
  lastFailureDiagnostic: string | null;
}

export interface BulkChangeSet {
  sourceCode: string;
  asOfUtc: string;
  projects: ProjectRecord[];
  milestones: MilestoneRecord[];
  notes: NoteRecord[];
  requests: RequestRecord[];
  deletions: EntityRef[];
  correlationId: string;
}

export interface BulkPersistResult {
  succeeded: boolean;
  projectsWritten: number;
  milestonesWritten: number;
  notesWritten: number;
  requestsWritten: number;
  deleted: number;
  issues: string[];
}

export interface CallerContext {
  userKey: string;
  principalId: string;
  displayName: string;
  role: string;
  teamCodes: string[];
  correlationId: string;
}

export interface ChangeFeed {
  items: ChangeFeedItem[];
  fromInclusiveUtc: string;
  generatedAtUtc: string;
  truncated: boolean;
}

export interface ChangeFeedItem {
  occurredAtUtc: string;
  actorDisplayName: string;
  category: string;
  sentence: string;
}

export interface ChangeFeedQuery {
  withinDays: number;
  maximumItems: number;
}

export interface ChangeNotification {
  entityType: string;
  entityKeys: string[];
  changeKind: string;
  dataAsOfUtc: string;
  correlationId: string;
}

export interface ChildLinkFinding {
  entityType: string;
  outcome: ChildLinkOutcome;
  businessProjectId: number | null;
  sourceIndex: number;
  label: string;
  candidateProjectKeys: string[];
}

export interface ChildLinkResult {
  milestones: KeyedRecord<MilestoneRecord>[];
  notes: KeyedRecord<NoteRecord>[];
  findings: ChildLinkFinding[];
}

export interface ColumnBinding {
  columnIndex: number;
  header: string;
  normalizedHeader: string;
  targetEntity: string | null;
  targetField: string | null;
  matchedByAlias: boolean;
  isRequired: boolean;
  referenceListCode: string | null;
}

export interface ConversionOptions {
  preferredRouteCode: string | null;
  embedFonts: boolean;
  timeout: string;
  allowExternalTenantRoundTrip: boolean;
}

export interface ConversionRoute {
  routeCode: string;
  sourceFormat: ArtifactFormat;
  targetFormat: ArtifactFormat;
  isAvailable: boolean;
  requiresExternalTenantRoundTrip: boolean;
  description: string;
  unavailableReason: string | null;
}

export interface ConverterHealth {
  isAvailable: boolean;
  routeCode: string;
  version: string | null;
  diagnostic: string | null;
  checkedAtUtc: string;
}

export interface DataFreshness {
  dataAsOfUtc: string;
  checkedAtUtc: string;
  sourceCode: string;
}

export interface DataQualityQuery {
  minimumSeverity: DataQualitySeverity;
  entityTypes: string[] | null;
  codes: string[] | null;
  owner: string | null;
  hideCompleted: boolean;
}

export interface DataQualityReport {
  generatedAtUtc: string;
  warnings: DataQualityWarning[];
  countsByCode: Record<string, number>;
  countsByEntityType: Record<string, number>;
  errorCount: number;
  warningCount: number;
  infoCount: number;
}

export interface DataQualitySubject {
  projectKey: string;
  projectName: string;
  owner: string | null;
}

export interface DataQualityWarning {
  code: string;
  severity: DataQualitySeverity;
  entityType: string;
  entityKey: string | null;
  message: string;
  field: string | null;
  rawValue: string | null;
  subject: DataQualitySubject | null;
}

export interface DateParsingOptions {
  placeholderTokens: string[];
  monthOnlyPatterns: string[];
  recognizedYears: YearRecognitionRange;
  monthOnlyInference: MonthOnlyYearInference;
  twoDigitYearPivotCentury: number;
  clampImpossibleDays: boolean;
  cultureName: string;
  relativeTo: string | null;
}

export interface DecisionItem {
  key: string;
  projectKey: string;
  projectName: string;
  text: string;
  urgency: string | null;
  urgencyColorHex: string | null;
  owner: string | null;
  neededByLabel: string | null;
  statusLabel: string;
  noteDate: string | null;
}

export interface DeckDocument {
  widthInches: number;
  heightInches: number;
  slides: SlideDocument[];
  assets: BrandAssetContent[];
}

export interface DeckGenerateRequest {
  reportDate: string;
  title: string;
  nextReportText: string | null;
  pinnedDetailProjectKeys: string[];
  excludedDetailProjectKeys: string[];
}

export interface DeckPreview {
  previewKey: string;
  header: ReportHeader;
  inventory: SlideInventory;
  detailProjects: ProjectView[];
  detailExplanation: DetailSelectionExplanation;
  quarterColumns: QuarterColumn[];
  counts: PortfolioCounts;
  quality: DataQualityReport;
  publishBlockers: ValidationIssue[];
}

export interface DeckPublishRequest {
  previewKey: string | null;
  reportDate: string;
  title: string;
  markFinal: boolean;
  nextReportText: string | null;
  pinnedDetailProjectKeys: string[];
  excludedDetailProjectKeys: string[];
}

export interface DeckVersionDetail {
  summary: DeckVersionSummary;
  header: ReportHeader;
  counts: PortfolioCounts;
  inventory: SlideInventory;
  integrity: SnapshotIntegrity;
  schemaVersion: string;
  createdAtUtc: string;
  createdByDisplayName: string;
}

export interface DeckVersionRecord {
  versionKey: string;
  state: DeckVersionState;
  title: string;
  reportDate: string;
  dataAsOfUtc: string;
  createdAtUtc: string;
  createdByPrincipalId: string;
  createdByDisplayName: string;
  publishedAtUtc: string | null;
  publishedByPrincipalId: string | null;
  publishedByDisplayName: string | null;
  schemaVersion: string;
  integrityHash: string;
  artifacts: ArtifactRef[];
  concurrencyToken: string | null;
}

export interface DeckVersionSummary {
  versionKey: string;
  state: DeckVersionState;
  title: string;
  reportDate: string;
  dataAsOfUtc: string;
  publishedAtUtc: string | null;
  publishedByDisplayName: string | null;
  artifacts: ArtifactRef[];
}

export interface DeleteResult {
  deleted: boolean;
  entity: EntityRef;
  cascadedCount: number;
  issues: ValidationIssue[];
}

export interface DerivationContext {
  referenceData: ReferenceDataSet;
  layout: LayoutSettings;
  today: string;
  nowUtc: string;
  outputCode: string;
}

export interface DetailSelectionExplanation {
  mode: DetailSelectionMode;
  minMilestones: number;
  candidateCount: number;
  selectedCount: number;
  selectedProjectKeys: string[];
  verdicts: DetailSelectionVerdict[];
  truncatedByMaxSlides: boolean;
  droppedByMaxSlidesCount: number;
}

export interface DetailSelectionSpec {
  mode: DetailSelectionMode;
  minMilestones: number;
  includedStatGroups: string[];
  pinnedProjectKeys: string[];
  excludedProjectKeys: string[];
  maxSlides: number | null;
}

export interface DetailSelectionVerdict {
  projectKey: string;
  projectName: string;
  isSelected: boolean;
  reason: DetailSelectionReason;
  milestoneCount: number;
  statGroup: string;
  position: number;
}

export interface DiffOptions {
  baselineVersionKey: string;
  comparandVersionKey: string;
  includeMilestoneChanges: boolean;
  ignoredFieldNames: string[];
}

export interface DiffSummary {
  addedProjectCount: number;
  removedProjectCount: number;
  changedProjectCount: number;
  fieldChangeCount: number;
  milestoneChangeCount: number;
  isIdentical: boolean;
}

export interface DirectoryPerson {
  principalId: string;
  displayName: string;
  userPrincipalName: string | null;
  email: string | null;
  jobTitle: string | null;
  department: string | null;
  isEnabled: boolean;
}

export interface DualRunRequest {
  baselineProfileCode: string;
  comparandProfileCode: string;
  ignoredFieldNames: string[];
  maxProjects: number | null;
}

export interface DuplicateBusinessIdGroup {
  businessProjectId: number;
  claimants: DuplicateClaimant[];
}

export interface DuplicateClaimant {
  key: string | null;
  name: string;
  sourceIndex: number;
}

export interface DuplicateKeyReport {
  groups: DuplicateBusinessIdGroup[];
  affectedRecordCount: number;
  recordsWithoutBusinessId: number;
}

export interface EntityBinding {
  targetEntity: string;
  sourceCollection: string;
  isRequired: boolean;
}

export interface EntityRef {
  entityType: string;
  entityKey: string;
}

export interface EntityVersionState {
  entityType: string;
  entityKey: string;
  concurrencyToken: string;
  updatedAtUtc: string | null;
  updatedBy: string | null;
}

export interface ExportRequest {
  source: ExportSource;
  versionKey: string | null;
  filter: RoadmapFilter | null;
}

export interface ExternalSyncRequest {
  sourceProfileCode: string;
  changedSinceUtc: string | null;
  maxProjects: number | null;
}

export interface FieldBinding {
  targetEntity: string;
  targetField: string;
  sourcePath: string;
  sourceAliases: string[];
  isRequired: boolean;
  referenceListCode: string | null;
}

export interface FieldChange {
  fieldName: string;
  beforeValue: string | null;
  afterValue: string | null;
}

export interface FieldChangeSet {
  sourceTypeName: string;
  entityKey: string | null;
  changes: FieldChange[];
  unchangedFields: string[];
  incomparableFields: string[];
}

export interface FieldMapActivationRequest {
  profileCode: string;
}

export interface FieldMapBindingResolution {
  targetEntity: string;
  targetField: string;
  sourcePath: string;
  matchedField: string | null;
  matchedByAlias: boolean;
  isRequired: boolean;
}

export interface FieldMapProfile {
  profileCode: string;
  sourceKind: string;
  version: string;
  entities: EntityBinding[];
  fields: FieldBinding[];
  unknownFields: UnknownFieldPolicy;
}

export interface FieldMapProfileSummary {
  profileCode: string;
  sourceKind: string;
  version: string;
  entityBindingCount: number;
  fieldBindingCount: number;
  unknownFields: UnknownFieldPolicy;
  updatedAtUtc: string;
  isActive: boolean;
}

export interface FieldMapSaveRequest {
  profile: FieldMapProfile;
  observedFields: string[];
}

export interface FieldMapValidation {
  profileCode: string;
  isUsable: boolean;
  resolutions: FieldMapBindingResolution[];
  unclaimedFields: string[];
  issues: FieldMapValidationIssue[];
}

export interface FieldMapValidationIssue {
  code: string;
  severity: DataQualitySeverity;
  detail: string;
  targetEntity: string | null;
  targetField: string | null;
  sourceField: string | null;
}

export interface FilterChoice {
  code: string;
  label: string;
  colorHex: string | null;
  displayOrder: number;
  matchCount: number;
}

export interface FontSpec {
  family: string;
  fallbacks: string[];
}

export interface GlanceGroup {
  title: string;
  displayOrder: number;
  rows: ProjectView[];
}

export interface GoLiveView {
  label: string;
  yearMonth: string | null;
  source: GoLiveSource;
  wasLabel: string | null;
  isSlip: boolean;
  quarterColumnKey: string;
  quarterReason: QuarterAssignmentReason;
}

export interface IdentityProviderHealth {
  isAvailable: boolean;
  providerKind: string;
  authority: string | null;
  tenantId: string | null;
  authorityReachable: boolean;
  directoryReachable: boolean;
  latency: string;
  checkedAtUtc: string;
  diagnostic: string | null;
}

export interface ImportCommitRequest {
  previewKey: string;
  upload: WorkbookUpload;
  acceptWarnings: boolean;
}

export interface ImportPreview {
  previewKey: string;
  tabsFound: string[];
  rowCountsByTab: Record<string, number>;
  columnBindings: ColumnBinding[];
  ignoredColumns: string[];
  warnings: DataQualityWarning[];
}

export interface ImportResult {
  previewKey: string;
  succeeded: boolean;
  asOfUtc: string;
  projectsWritten: number;
  milestonesWritten: number;
  notesWritten: number;
  requestsWritten: number;
  unmappedValues: UnmappedValue[];
  warnings: DataQualityWarning[];
  issues: string[];
}

export interface KeyedRecord<TRecord> {
  key: string;
  record: TRecord;
  keyWasAssigned: boolean;
  hasDuplicateBusinessId: boolean;
}

export interface LayoutSettings {
  goLivePrecedence: GoLivePrecedence;
  goLiveDescriptionPatterns: string[];
  preferExplicitGoLiveFlag: boolean;
  glanceRowCapWithStats: number;
  glanceRowCapPlain: number;
  riskDecisionItemsPerSlide: number;
  requestsPerSlide: number;
  truncationAllowed: boolean;
  outputProfiles: OutputLayoutProfile[];
  detailSelection: DetailSelectionSpec;
  quarterPolicy: QuarterPolicy;
  resolvedQuarterColumns: QuarterColumn[];
  presenter: PresenterBlock;
  dateParsing: DateParsingOptions;
}

export interface LayoutSettingsSaveRequest {
  settings: LayoutSettings;
  concurrencyToken: string | null;
}

export interface LifecycleColumnSpec {
  key: string;
  label: string;
  statGroups: string[];
}

export interface LifecycleTransition {
  current: DeckVersionState;
  action: DeckVersionAction;
  isAllowed: boolean;
  resultingState: DeckVersionState;
  changesState: boolean;
  reasonCode: string | null;
  reason: string;
  actorPrincipalId: string;
  actorDisplayName: string;
  evaluatedAtUtc: string;
  correlationId: string;
}

export interface MilestoneChange {
  milestoneKey: string;
  label: string;
  kind: MilestoneChangeKind;
  fieldChanges: FieldChange[];
}

export interface MilestoneDetail {
  milestone: MilestoneRecord;
  view: MilestoneView | null;
}

export interface MilestoneOrder {
  projectKey: string;
  milestones: MilestoneView[];
  nextMilestone: NextMilestoneView | null;
}

export interface MilestoneOrderEntry {
  milestoneKey: string;
  sortOrder: number;
}

export interface MilestoneRecord {
  key: string | null;
  businessProjectId: number | null;
  projectKey: string | null;
  description: string | null;
  rawDate: unknown | null;
  rawCompletion: string | null;
  isGoLiveFlag: boolean | null;
  sortOrder: number | null;
  rawMilestoneTeam: string | null;
  concurrencyToken: string | null;
}

export interface MilestoneReorderRequest {
  projectKey: string;
  orderedMilestoneKeys: string[];
}

export interface MilestoneSaveRequest {
  milestone: MilestoneRecord;
  concurrencyToken: string | null;
}

export interface MilestoneView {
  key: string;
  label: string;
  completionLabel: string;
  completionColorHex: string;
  dateLabel: string;
  yearMonth: string | null;
  sortOrder: number;
  isGoLive: boolean;
  isComplete: boolean;
}

export interface MonthOnlyYearInference {
  pivotMonth: number;
  yearAtOrAfterPivot: number;
  yearBeforePivot: number;
}

export interface NextMilestoneView {
  label: string;
  dateLabel: string;
  milestoneKey: string | null;
}

export interface NoteDetail {
  note: NoteRecord;
  status: StatusView;
}

export interface NoteRecord {
  key: string | null;
  businessProjectId: number | null;
  projectKey: string | null;
  rawType: string | null;
  text: string | null;
  rawStatus: string | null;
  rawNoteDate: unknown | null;
  rawSeverity: string | null;
  rawUrgency: string | null;
  owner: string | null;
  rawNeededBy: unknown | null;
  concurrencyToken: string | null;
}

export interface NoteSaveRequest {
  note: NoteRecord;
  concurrencyToken: string | null;
}

export interface OutputLayoutProfile {
  outputCode: string;
  statCards: StatCardSpec[];
  milestoneDisplay: MilestoneDisplayMode;
  milestoneCap: number | null;
  milestoneOverflowLabelFormat: string | null;
  emptyCellPlaceholder: string;
}

export interface PagedResult<TItem> {
  items: TItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
}

export interface ParsedDate {
  kind: DateParseKind;
  value: string | null;
  yearMonth: string | null;
  rawText: string;
  placeholderToken: string | null;
  diagnosticCode: string | null;
  dayWasClamped: boolean;
}

export interface PersistResult {
  succeeded: boolean;
  concurrencyToken: string | null;
  entityKey: string | null;
  issues: string[];
}

export interface PlaceholderColumnSpec {
  key: string;
  label: string;
  tokens: string[];
}

export interface PortableWriteOptions {
  inlineAssets: boolean;
  includeInteractiveFilters: boolean;
  cssCompatibility: CssCompatibilityLevel;
  printStylesheetOverride: string | null;
}

export interface PortableWriterCapabilities {
  supportsInteractiveFilters: boolean;
  supportsInlineAssets: boolean;
  supportedCssLevels: CssCompatibilityLevel[];
  maxDocumentBytes: number;
}

export interface PortfolioCounts {
  total: number;
  byStatGroup: Record<string, number>;
  byStatus: Record<string, number>;
  cards: StatCardValue[];
}

export interface PortfolioQuery {
  includeMilestones: boolean;
  includeNotes: boolean;
  includeRequests: boolean;
  changedSinceUtc: string | null;
  businessProjectIds: number[];
  maxProjects: number | null;
}

export interface PortfolioSourceContext {
  sourceCode: string;
  map: FieldMapProfile;
  credentialReference: string;
  requestedAsOfUtc: string;
  correlationId: string;
}

export interface PortfolioSourceRecords {
  asOfUtc: string;
  sourceCode: string;
  projects: ProjectRecord[];
  milestones: MilestoneRecord[];
  notes: NoteRecord[];
  requests: RequestRecord[];
  unmappedValues: UnmappedValue[];
  ignoredColumns: string[];
}

export interface PresentationCapabilities {
  writerName: string;
  formatVersion: string;
  maxSlideWidthInches: number;
  maxSlideHeightInches: number;
  supportedElements: SlideElementKind[];
  supportsTextMeasurement: boolean;
}

export interface PresenterBlock {
  displayName: string;
  contactLine: string;
  nextReportText: string;
}

export interface PrincipalIdentity {
  principalId: string;
  displayName: string;
  userPrincipalName: string | null;
  email: string | null;
  tenantId: string;
  directoryGroupIds: string[];
  directoryRoles: string[];
  authenticatedAtUtc: string;
  expiresAtUtc: string;
}

export interface ProductRecord {
  key: string | null;
  name: string;
  technologyOwner: string | null;
  businessOwner: string | null;
  isActive: boolean;
  concurrencyToken: string | null;
  updatedAtUtc: string | null;
  updatedBy: string | null;
}

export interface ProductSaveRequest {
  product: ProductRecord;
  concurrencyToken: string | null;
}

export interface ProjectDetail {
  project: ProjectRecord;
  status: StatusView;
  percentComplete: number | null;
  milestones: MilestoneView[];
  milestoneRecords: MilestoneRecord[];
  nextMilestone: NextMilestoneView | null;
  notes: NoteRecord[];
  warnings: DataQualityWarning[];
}

export interface ProjectFieldChanges {
  projectKey: string;
  projectName: string;
  fieldChanges: FieldChange[];
  milestoneChanges: MilestoneChange[];
}

export interface ProjectOwnerSummary {
  displayName: string;
  projectCount: number;
}

export interface ProjectQuery {
  nameContains: string | null;
  teamCodes: string[];
  statusCodes: string[];
  businessProjectId: number | null;
  hideCompleted: boolean;
  scope: ScopeFilter | null;
  pageNumber: number;
  pageSize: number;
}

export interface ProjectRecord {
  key: string | null;
  businessProjectId: number | null;
  name: string;
  rawTeam: string | null;
  owner: string | null;
  description: string | null;
  rawStatus: string | null;
  rawPercentComplete: unknown | null;
  rawOriginalGoLive: unknown | null;
  rawCurrentGoLive: unknown | null;
  rawRecastCount: unknown | null;
  featureDetails: string | null;
  subgroup: string | null;
  productKey: string | null;
  businessOwner: string | null;
  concurrencyToken: string | null;
  updatedAtUtc: string | null;
  updatedBy: string | null;
}

export interface ProjectSaveRequest {
  project: ProjectRecord;
  concurrencyToken: string | null;
}

export interface ProjectSummary {
  projectKey: string;
  businessProjectId: number | null;
  name: string;
  rawTeam: string | null;
  owner: string | null;
  productKey: string | null;
  businessOwner: string | null;
  status: StatusView;
  percentComplete: number | null;
  updatedAtUtc: string | null;
  updatedBy: string | null;
  concurrencyToken: string | null;
}

export interface ProjectView {
  key: string;
  businessProjectId: number | null;
  hasDuplicateBusinessId: boolean;
  name: string;
  team: string;
  teamGroup: string;
  owner: string;
  description: string;
  status: StatusView;
  percentComplete: number | null;
  next: NextMilestoneView;
  goLive: GoLiveView;
  milestones: MilestoneView[];
  risks: RiskItem[];
  decisions: DecisionItem[];
  subgroup: string | null;
  featureDetails: string | null;
}

export interface QuarterAssignment {
  columnKey: string;
  reason: QuarterAssignmentReason;
}

export interface QuarterCardSelector {
  mode: QuarterSelectorMode;
  explicitColumnKey: string | null;
}

export interface QuarterColumn {
  key: string;
  label: string;
  startInclusive: string | null;
  endExclusive: string | null;
  isOpenEnded: boolean;
  isCatchAll: boolean;
  displayOrder: number;
}

export interface QuarterKey {
  year: number;
  quarter: number;
}

export interface QuarterPolicy {
  forwardColumnCount: number;
  includeCatchAll: boolean;
  catchAllLabel: string;
  openEndedLabelFormat: string;
  placeholderColumns: PlaceholderColumnSpec[];
  lifecycleColumns: LifecycleColumnSpec[];
}

export interface QueuedMessage {
  messageKey: string;
  queueName: string;
  messageType: string;
  payload: string;
  enqueuedAtUtc: string;
  correlationId: string;
  deliveryCount: number;
}

export interface ReconciledRecords {
  records: PortfolioSourceRecords;
  projectsMatched: number;
  milestonesMatched: number;
  notesMatched: number;
  requestsMatched: number;
}

export interface ReconciliationResult {
  entityType: string;
  entityKey: string;
  outcome: MergeOutcome;
  appliedChanges: FieldChange[];
  fieldsToWrite: string[];
  fieldsNotWritten: string[];
  writeAgainstToken: string;
}

export interface ReferenceDataSet {
  version: string;
  lists: ReferenceList[];
}

export interface ReferenceList {
  listCode: string;
  displayName: string;
  allowsColor: boolean;
  allowsGrouping: boolean;
  values: ReferenceValue[];
}

export interface ReferenceListDetail {
  list: ReferenceList;
  includesInactive: boolean;
  activeValueCount: number;
  retiredValueCount: number;
}

export interface ReferenceListSummary {
  listCode: string;
  displayName: string;
  allowsColor: boolean;
  allowsGrouping: boolean;
  activeValueCount: number;
  retiredValueCount: number;
}

export interface ReferenceUsage {
  valueKey: string;
  referencingRowCount: number;
  sites: UsageSite[];
  canHardDelete: boolean;
}

export interface ReferenceValue {
  key: string;
  listCode: string;
  code: string;
  canonicalLabel: string;
  shortLabel: string | null;
  colorHex: string | null;
  displayOrder: number;
  sortTier: number;
  sortRank: number;
  isActive: boolean;
  groupCode: string | null;
  aliases: string[];
  attributes: Record<string, string>;
}

export interface ReferenceValueSaveRequest {
  value: ReferenceValue;
  concurrencyToken: string | null;
}

export interface ReportHeader {
  title: string;
  reportDate: string;
  dataAsOfUtc: string;
  publishedAtUtc: string | null;
  publishedByDisplayName: string | null;
  publishedByPrincipalId: string | null;
}

export interface ReportModel {
  counts: PortfolioCounts;
  glanceGroups: GlanceGroup[];
  detail: ProjectView[];
  risks: RiskItem[];
  decisions: DecisionItem[];
  requests: RequestView[];
  board: RoadmapBoard;
  warnings: DataQualityWarning[];
}

export interface ReportSnapshot {
  schemaVersion: string;
  header: ReportHeader;
  model: ReportModel;
  referenceData: ReferenceDataSet;
  branding: BrandingTokens;
  layout: LayoutSettings;
  integrityHash: string;
}

export interface RequestDetail {
  request: RequestRecord;
  disposition: StatusView;
}

export interface RequestRecord {
  key: string | null;
  name: string | null;
  requestor: string | null;
  rawTeam: string | null;
  description: string | null;
  rawNeededBy: unknown | null;
  rawLoe: string | null;
  rawPriority: string | null;
  criticalResources: string | null;
  rawDisposition: string | null;
  ahaId: string | null;
  concurrencyToken: string | null;
}

export interface RequestSaveRequest {
  request: RequestRecord;
  concurrencyToken: string | null;
}

export interface RequestView {
  key: string;
  name: string;
  requestor: string;
  team: string;
  description: string;
  neededByLabel: string;
  loe: string;
  priority: string;
  disposition: string;
  dispositionColorHex: string;
  ahaId: string | null;
  criticalResources: string | null;
}

export interface ResolvedValue {
  isMapped: boolean;
  value: ReferenceValue | null;
  rawValue: string;
  listCode: string;
}

export interface ResourceDescriptor {
  entityType: string;
  entityKey: string | null;
  teamCode: string | null;
  ownerPrincipalId: string | null;
}

export interface RetirementImpact {
  valueKey: string;
  referencingRowCount: number;
  sites: UsageSite[];
  canHardDelete: boolean;
  assessedAtUtc: string;
}

export interface RiskItem {
  key: string;
  projectKey: string;
  projectName: string;
  text: string;
  severity: string | null;
  severityColorHex: string | null;
  statusLabel: string;
  noteDate: string | null;
  typeLabel: string;
  isOpen: boolean;
}

export interface RoadmapBoard {
  columns: QuarterColumn[];
  swimlanes: Swimlane[];
}

export interface RoadmapFilter {
  teamGroups: string[] | null;
  statuses: string[] | null;
  teams: string[] | null;
  searchTerm: string | null;
}

export interface RoadmapFilterOptions {
  areas: FilterChoice[];
  statuses: FilterChoice[];
  semantics: RoadmapFilterSemantics;
}

export interface RoadmapFilterSemantics {
  areaSelection: FilterSelectionMode;
  areaEffectOnBoard: FilterEffect;
  areaEffectOnCards: FilterEffect;
  statusSelection: FilterSelectionMode;
  statusEffectOnBoard: FilterEffect;
  statusEffectOnCards: FilterEffect;
  dimmedOpacity: number;
  hideGroupWhenNoVisibleCards: boolean;
}

export interface RoadmapView {
  header: ReportHeader;
  board: RoadmapBoard;
  cards: GlanceGroup[];
  counts: PortfolioCounts;
  referenceData: ReferenceDataSet;
  branding: BrandingTokens;
  profile: OutputLayoutProfile;
  filterSemantics: RoadmapFilterSemantics;
  warnings: DataQualityWarning[];
}

export interface RoleAssignmentRequest {
  principalId: string;
  role: string;
  concurrencyToken: string | null;
}

export interface SaveResult<TEntity> {
  entity: TEntity | null;
  saved: boolean;
  issues: ValidationIssue[];
  staleness: StalenessWarning | null;
  concurrencyToken: string | null;
}

export interface ScopeFilter {
  isUnrestricted: boolean;
  teamCodes: string[];
  ownerPrincipalId: string | null;
}

export interface SlideDocument {
  slideKind: string;
  title: string | null;
  subTitle: string | null;
  backgroundToken: string;
  showChrome: boolean;
  elements: SlideElement[];
}

export interface SlideElement {
  elementKind: SlideElementKind;
  bounds: SlideRect;
  colorToken: string | null;
  text: string | null;
  style: TextStyle | null;
  assetRole: string | null;
  table: TableElement | null;
  geometry: ShapeGeometry;
  fillOpacity: number;
}

export interface SlideInventory {
  totalSlideCount: number;
  sections: SlideInventorySection[];
  slideKindsInOrder: string[];
}

export interface SlideInventorySection {
  slideKind: string;
  slideCount: number;
  firstSlideOrdinal: number;
}

export interface SlidePlan {
  slideKind: string;
  groupTitle: string;
  pageNumberInGroup: number;
  pageCountInGroup: number;
  carriesStatCards: boolean;
  rowCap: number;
  firstRowIndex: number;
  rows: ProjectView[];
}

export interface SlideRect {
  xInches: number;
  yInches: number;
  widthInches: number;
  heightInches: number;
}

export interface SnapshotFreezeRequest {
  model: ReportModel;
  referenceData: ReferenceDataSet;
  branding: BrandingTokens;
  resolvedLayout: LayoutSettings;
  header: ReportHeader;
  schemaVersion: string;
}

export interface SnapshotIntegrity {
  isIntact: boolean;
  expectedHash: string;
  actualHash: string;
  issues: string[];
}

export interface SourceCapabilities {
  supportsWrite: boolean;
  supportsMilestones: boolean;
  supportsTypedNotes: boolean;
  supportsRequests: boolean;
  supportsIncremental: boolean;
  vocabularyOwnership: string;
}

export interface SourceComparison {
  baselineSourceCode: string;
  comparandSourceCode: string;
  baselineAsOfUtc: string;
  comparandAsOfUtc: string;
  onlyInBaseline: ProjectView[];
  onlyInComparand: ProjectView[];
  differing: SourceProjectDifference[];
  identicalProjectCount: number;
  warnings: DataQualityWarning[];
}

export interface SourceHealth {
  isReachable: boolean;
  sourceCode: string;
  checkedAtUtc: string;
  latency: string;
  detail: string | null;
}

export interface SourceProjectDifference {
  projectKey: string;
  projectName: string;
  fieldChanges: FieldChange[];
}

export interface SourceValue {
  rawValue: string;
  occurrences: number;
}

export interface SourceValueList {
  listCode: string;
  sourceField: string;
  values: SourceValue[];
}

export interface SpellingTally {
  spelling: string;
  occurrences: number;
}

export interface StalenessWarning {
  isStale: boolean;
  changedFields: string[];
  lastChangedBy: string | null;
  lastChangedAtUtc: string | null;
}

export interface StatCardSpec {
  label: string;
  kind: StatCardKind;
  statGroups: string[];
  quarter: QuarterCardSelector | null;
  colorToken: string;
  displayOrder: number;
}

export interface StatCardValue {
  label: string;
  value: number;
  colorToken: string;
  displayOrder: number;
  memberProjectKeys: string[];
  memberNoteKeys: string[];
}

export interface StateChangeStamp {
  actorPrincipalId: string;
  actorDisplayName: string;
  atUtc: string;
  correlationId: string;
}

export interface StatusView {
  canonical: string;
  shortLabel: string;
  colorHex: string;
  sortTier: number;
  sortRank: number;
  statGroup: string;
  isMapped: boolean;
  rawValue: string;
}

export interface Swimlane {
  teamGroup: string;
  displayOrder: number;
  chips: BoardChip[];
}

export interface SwimlaneDefinition {
  teamGroupCode: string;
  title: string;
  displayOrder: number;
  teamCodes: string[];
}

export interface SyncResult {
  sourceCode: string;
  asOfUtc: string;
  succeeded: boolean;
  projectsWritten: number;
  milestonesWritten: number;
  notesWritten: number;
  requestsWritten: number;
  unmappedValues: UnmappedValue[];
  warnings: DataQualityWarning[];
  issues: string[];
}

export interface TableCellElement {
  text: string;
  style: TextStyle | null;
  fillColorToken: string | null;
  columnSpan: number;
}

export interface TableElement {
  columnWidthsInches: number[];
  rows: TableRowElement[];
}

export interface TableRowElement {
  heightInches: number;
  cells: TableCellElement[];
}

export interface TeamPlacement {
  teamCode: string;
  team: string;
  teamGroupCode: string;
  teamGroup: string;
  teamDisplayOrder: number;
  teamGroupDisplayOrder: number;
  isMapped: boolean;
  rawValue: string;
}

export interface TextMetrics {
  widthInches: number;
  heightInches: number;
  lineCount: number;
  fitsOnOneLine: boolean;
}

export interface TextStyle {
  fontRole: string;
  fontSizePoints: number;
  isBold: boolean;
  isItalic: boolean;
  colorToken: string;
  alignment: TextAlignment;
  lineSpacingMultiple: number;
}

export interface UnmappedValue {
  listCode: string;
  rawValue: string;
  entityType: string;
  entityKey: string | null;
  occurrences: number;
}

export interface UsageSite {
  entityType: string;
  field: string;
  rowCount: number;
}

export interface UserProfile {
  userKey: string;
  principalId: string;
  displayName: string;
  email: string | null;
  role: string;
  isEnabled: boolean;
  roleAssignedAtUtc: string | null;
  roleAssignedByPrincipalId: string | null;
  concurrencyToken: string | null;
}

export interface UserQuery {
  searchTerm: string | null;
  role: string | null;
  includeDisabled: boolean;
  pageNumber: number;
  pageSize: number;
}

export interface ValidationIssue {
  field: string | null;
  code: string;
  message: string;
  normalizedValue: string | null;
}

export interface VersionDiff {
  baselineVersionKey: string;
  comparandVersionKey: string;
  addedProjects: ProjectView[];
  removedProjects: ProjectView[];
  changedProjects: ProjectFieldChanges[];
  summary: DiffSummary;
}

export interface VersionQuery {
  state: DeckVersionState | null;
  reportDateFromInclusive: string | null;
  reportDateToInclusive: string | null;
  titleContains: string | null;
  pageNumber: number;
  pageSize: number;
}

export interface WorkbookMapResult {
  records: PortfolioSourceRecords;
  warnings: DataQualityWarning[];
  isUsable: boolean;
}

export interface WorkbookReadOptions {
  tabNames: string[];
  useTableRangesWhenPresent: boolean;
  dropEmptyAutoNamedColumns: boolean;
  dropTrailingBlankRows: boolean;
  maxRowsPerTab: number;
  maxColumnsPerTab: number;
}

export interface WorkbookTab {
  name: string;
  headers: string[];
  rows: unknown | null[][];
}

export interface WorkbookTabDescriptor {
  name: string;
  position: number;
  isVisible: boolean;
  dataRowCount: number;
  headers: string[];
  tableNames: string[];
}

export interface WorkbookTabular {
  tabs: WorkbookTab[];
}

export interface WorkbookUpload {
  fileName: string;
  content: string;
  sourceProfileCode: string | null;
  tabNames: string[];
}

export interface WorkbookWriteOptions {
  fileName: string;
  createTablePerTab: boolean;
  freezeHeaderRow: boolean;
  dateNumberFormat: string | null;
}

export interface YearRecognitionRange {
  minYear: number;
  maxYear: number;
}

